import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { TmarkPriorityContent } from 'src/types/api/trademarkRightsApiTypes';
import { Table, Item, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: TmarkPriorityContent;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 商標優先權 區塊。
 */
const InfoTmarkPriority: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType, noContent }) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;

  return (
    <DropdownInfo title={`商標優先權`} isShow={isShow} setIsShow={setIsShow} color={angleColor}>
      <Table color={tableColor}>
        <Item>
          <Title>優先權序號</Title>
          <Content>{data.sequence || noContent}</Content>
          <Title>優先權日期</Title>
          <Content>{data.priority.date || noContent}</Content>
        </Item>
        <Item>
          <Title>優先權類別</Title>
          <Content>{data.priority.type || noContent}</Content>
          <Title>首次申請國家</Title>
          <Content>{data.priority.country || noContent}</Content>
        </Item>
        <Item>
          <Title>展覽會名稱</Title>
          <Content>{data.priority.remark || noContent}</Content>
        </Item>
      </Table>
    </DropdownInfo>
  );
};

export default InfoTmarkPriority;
